import { isEmpty, isNotNil } from 'ramda'
import useUpcomingProjects from './useUpcomingProjects'

const useFeaturedProject = (type: 'labs' | 'launch') => {
  const { pools: upcomingProjects } = useUpcomingProjects(type)
  const featuredProject = upcomingProjects.find(
    (project) => project?.cmsData?.isFeaturedProject,
  )
  // const project = upcomingProjects.filter((project) => project?.cmsData)?.[0]
  return isNotNil(featuredProject) && !isEmpty(featuredProject)
    ? featuredProject
    : null
}

export default useFeaturedProject
